<template>
  <div>
    <label
      :for="`input-${fieldProperties.key}`"
      :style="styleProperty"
      :class="fieldProperties.required ? 'required' : null"
    >
      {{
        $i18n.locale == 'th'
          ? fieldProperties.label_th
          : fieldProperties.label_en
      }}
    </label>
    <b-form-input
      :id="`input-${fieldProperties.key}`"
      v-model="fieldValue"
      :placeholder="
        $i18n.locale == 'th'
          ? fieldProperties.placeholder_th
          : fieldProperties.placeholder_en
      "
      :required="fieldProperties.required || textboxField.required"
      :maxlength="fieldProperties.field_property.maxlength"
      :style="fieldStyleProperty"
      :readonly="fieldProperties.readonly || textboxField.readonly"
      class="textbox-input"
      :disabled="fieldProperties.disabled || false"
      :type="fieldProperties.type || 'text'"
    />
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'
import {
  onBeforeMount, computed, ref, watch,
} from '@vue/composition-api'

import { textboxField } from '@/configs/dynamic-config/dynamic-field'

export default {
  components: { BFormInput },
  props: {
    fieldProperties: Object,
  },

  setup(props) {
    const fieldValue = ref(props.fieldProperties.value || null)

    const styleProperty = computed(() => ({
      color:
        props.fieldProperties.field_property.color_font
        || textboxField.color_font,
      fontSize:
        props.fieldProperties.field_property.font_size || textboxField.fontSize,
    }))

    const fieldStyleProperty = computed(() => ({
      color:
        props.fieldProperties.field_property.color_font
        || textboxField.color_font,
      fontSize:
        props.fieldProperties.field_property.font_size || textboxField.fontSize,
      width: '100%',
      maxWidth:
        props.fieldProperties.field_property.width || textboxField.width,
    }))

    const initFieldValue = value => {
      fieldValue.value = value || null
    }

    watch(
      () => props.fieldProperties.value,
      () => {
        initFieldValue(props.fieldProperties.value)
      },
      { deep: true },
    )

    return {
      styleProperty,
      textboxField,
      fieldStyleProperty,
      fieldValue,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
